import { replace } from 'react-router-redux';

export const CREATE_TEXT_PARAGRAPH = 'CREATE_TEXT_PARAGRAPH';
export const CREATE_IMAGE_PARAGRAPH = 'CREATE_IMAGE_PARAGRAPH';
export const UPDATE_TEXT_PARAGRAPH = 'UPDATE_TEXT_PARAGRAPH';
export const UPDATE_PARAGRAPH_IMAGE = 'UPDATE_PARAGRAPH_IMAGE';
export const MOVE_PARAGRAPH_UP = 'MOVE_PARAGRAPH_UP';
export const MOVE_PARAGRAPH_DOWN = 'MOVE_PARAGRAPH_DOWN';
export const ADD_IMAGE = 'ADD_IMAGE';
export const REMOVE_PARAGRAPH = 'REMOVE_PARAGRAPH';

function textParagraphCreated(chapter, fields) {
  return {
    type: CREATE_TEXT_PARAGRAPH,
    payload: {
      chapter,
      fields,
    },
  };
}

function imageParagraphCreated(chapter, image, thumbnail) {
  return {
    type: CREATE_IMAGE_PARAGRAPH,
    payload: {
      chapter,
      image,
      thumbnail,
    },
  };
}

export function createTextParagraph(chapter, fields) {
  return dispatch => {
    dispatch(textParagraphCreated(chapter, fields));
    dispatch(replace('/'));
  };
}

export function createImageParagraph(chapter, file) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      // Loading file as url
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () => {
          resolve(reader.result);
        },
        false
      );

      reader.readAsDataURL(file);
    }).then(thumbnail =>
      dispatch(imageParagraphCreated(chapter, file, thumbnail))
    );
  };
}

export function updateTextParagraph(id, fields) {
  return {
    type: UPDATE_TEXT_PARAGRAPH,
    payload: {
      id,
      fields,
    },
  };
}

export function moveParagraphUp(paragraph) {
  return {
    type: MOVE_PARAGRAPH_UP,
    payload: {
      paragraph,
    },
  };
}

export function moveParagraphDown(paragraph) {
  return {
    type: MOVE_PARAGRAPH_DOWN,
    payload: {
      paragraph,
    },
  };
}

export function removeParagraph(paragraph) {
  return {
    type: REMOVE_PARAGRAPH,
    payload: {
      paragraph,
    },
  };
}



// WEBPACK FOOTER //
// ./src/modules/memo/actions/paragraphs.js